const About = ()=>{
    return(
        <div>
            <h1>About Us</h1>
            <h2>Practicing my react conceprt</h2>
        </div>
    )
}
export default About;